import React from 'react';
import { Instagram } from 'lucide-react';
import heroBg from '../../../assets/hero-bg.jpg';

export const LandingPage: React.FC = () => {
  return (
    <>
      {/* Hero */}
      <section
        className="relative bg-primary text-primary-foreground"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/20" />
        <div className="container relative py-40 md:py-56" />
      </section>

      {/* About short */}
      <section className="bg-background">
        <div className="container py-16 md:py-20 text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl text-primary mb-6">
            O pandeiro está em toda a música brasileira.<br />Agora ele tem uma casa.
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            A Casa do Pandeiro fica no centro do Rio, um espaço dedicado à sua prática, memória e
            comunidade, com exposição, aulas, loja e eventos.
          </p>
          <a
            href="https://www.instagram.com/casadopandeiro/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-6 text-primary/80 hover:text-primary transition-colors text-sm"
          >
            <Instagram className="w-4 h-4" />
            Ver perfil no Instagram
          </a>
        </div>
      </section>

      {/* Instagram Feed */}
      <section className="bg-background">
        <div className="container py-10 md:py-14 max-w-4xl mx-auto text-center">
          {/* Substitua pelo código do widget Elfsight */}
          <div className="elfsight-app-XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX" data-elfsight-app-lazy></div>
        </div>
      </section>
    </>
  );
};
